import RemoveFilter from "components/Blocks/RemoveFilter/RemoveFilter";

export default RemoveFilter;
